import classNames from 'classnames';
import { forwardRef } from 'react';
const mobileShellRootCss = "m1sde5t0";
export const MobileShellRoot = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileShellRootCss, props.className)} />;
});
const mobileShellContentCss = "mlbep3y";
export const MobileShellContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileShellContentCss, props.className)} />;
});
const mobileShellBodyCss = "m1l7pcfy";
export const MobileShellBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileShellBodyCss, props.className)} />;
});
const navigatorItemsCss = "n1vdirh7";
export const NavigatorItems = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorItemsCss, props.className)} />;
});
const navigatorLeadingCss = "nznhrgn";
export const NavigatorLeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorLeadingCss, props.className)} />;
});
const navigatorTitleCss = "n2vgo2";
export const NavigatorTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorTitleCss, props.className)} />;
});
const navigatorWrapperCss = "n38wx8b";
export const NavigatorWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorWrapperCss, props.className)} />;
});

require("./mobile_shell_styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./mobile_shell_styles.js");